import Card from "@mui/material/Card";
import SoftUITabs from "./SoftUITabs/SoftUITabs";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import env from "config";
import { useAgencyInfo } from "context/agency";
import { useEffect, useState } from "react";
import General from "./BrandingTabs/General";
import "./style.css";
import { CircularProgress, Snackbar, useMediaQuery, useTheme } from "@mui/material";
import Domain from "./BrandingTabs/Domain";
import { useAppServices } from "hook/services";
import imageDemo from "assets/images/image.jpg";
import Content from "./BrandingTabs/Content";
import OtherPage from "./BrandingTabs/OtherPages";
import CategoryManager from "./BrandingTabs/Category";
import SubCategoryManager from "./BrandingTabs/SubCategory";
import breakpoints from "assets/theme/base/breakpoints";
import CustomTabs from "layouts/super-admin/components/CustomTabs";
import Menu from "./BrandingTabs/Menu";
import toast from "react-hot-toast";
import Loader from "examples/Loader";

function BasicInfo({ handleImage, loading }) {
  const { values } = breakpoints;
  const Service = useAppServices();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const customUrlDomain = env.ACCOUNT_LEVEL_URL;
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [gateway, setGatway] = useState("");
  const [agency, , , , , , Update] = useAgencyInfo();
  const [copy, setcopy] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState([]);
  const [themes, setThemes] = useState([]);
  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [themeStatus, setThemeStatus] = useState("inactive");
  const [categories, setCategories] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);

  const url = agency?.domain
    ? `https://${agency.domain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`
    : `${customUrlDomain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`;
  const handlecopy = () => {
    setcopy(true);

    setTimeout(() => {
      setcopy(false);
    }, 2000);
  };

  const handelThemeData = async (data, setResponseMessage, setOpen) => {
    setButtonLoading(true);
    try {
      const submitData = {
        ...selectedTheme,
      };

      if (submitData.theme_data && submitData.theme_data.domain) {
        submitData.theme_data.domain.domain_update = false;
      }
      // Deep merge general and content objects to preserve existing data
      const updatedThemeData = {
        ...submitData.theme_data,
        // Deep merge general object
        general: {
          ...submitData.theme_data?.general,
          ...data?.general,
        },
        // Deep merge content object
        content: {
          ...submitData.theme_data?.content,
          ...data?.content,
        },
        // Preserve other properties from data (like domain, menu_customize, pages, etc.)
        ...Object.keys(data || {}).reduce((acc, key) => {
          if (key !== "general" && key !== "content") {
            acc[key] = data[key];
          }
          return acc;
        }, {}),
      };
      if (updatedThemeData?.general?.logo && !updatedThemeData?.general?.logo.includes("https")) {
        return toast.error("Error while uploading Logo");
      }

      if (
        updatedThemeData?.general?.Meta_logo &&
        !updatedThemeData?.general?.Meta_logo.includes("https")
      ) {
        return toast.error("Error while uploading Meta Logo");
      }

      if (
        updatedThemeData?.general?.footer_logo &&
        !updatedThemeData?.general?.footer_logo.includes("https")
      ) {
        return toast.error("Error while uploading Footer Logo");
      }

      if (
        updatedThemeData?.general?.auth_logo &&
        !updatedThemeData?.general?.auth_logo.includes("https")
      ) {
        return toast.error("Error while uploading Auth Logo");
      }

      const payload = {
        agency_id: agency?._id,
        theme_data: updatedThemeData,
        theme_type: "agency",
        theme_id: selectedTheme.theme_id,
      };
      const { response, error } = await Service.themes.updateOrCreateByAgencyId({ payload });
      if (response?.success) {
        setSelectedTheme((prev) => ({
          ...prev,
          theme_data: updatedThemeData,
        }));
        setResponseMessage("Theme Updated Successfully");
        setOpen(true);
        setSuccessMsg(true);
        setErrorMsg(false);
      } else {
        setSuccessMsg(false);
        setResponseMessage(error?.message || "Failed to update theme");
        setErrorMsg(error?.message || false);
      }
    } catch (error) {
      setErrorMsg(true);
      if (error?.response?.status === 504) {
        setGatway(true);
        setResponseMessage("Theme Updated Successfully");
      } else if (error?.message?.includes("Network Error") || error?.code === "ECONNABORTED") {
        setGatway(true);
        setResponseMessage("Theme Updated Successfully");
      }
    } finally {
      setButtonLoading(false);
    }
  };
  const getCategories = async () => {
    try {
      const { response } = await Service.topnav_categories.get({
        query: `agency_id=${agency._id}`,
      });
      setCategories(response?.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  const tabsData = [
    {
      label: "General",
      key: "general",
      content: (
        <General
          selectedTheme={selectedTheme}
          handelThemeData={handelThemeData}
          handleImage={handleImage}
          loading={loading}
          buttonLoading={buttonLoading}
        />
      ),
    },
    {
      label: "Domain",
      content: (
        <Domain
          selectedTheme={selectedTheme}
          handleImage={handleImage}
          handelThemeData={handelThemeData}
          open={open}
          setOpen={setOpen}
          loading={loading}
          buttonLoading={buttonLoading}
          errorMsg={errorMsg}
          successMsg={successMsg}
          gateway={gateway}
        />
      ),
    },
    // {
    //   label: "Pages",
    //   content: (
    //     <OtherPage
    //       selectedTheme={selectedTheme}
    //       handleImage={handleImage}
    //       handelThemeData={handelThemeData}
    //       buttonLoading={buttonLoading}
    //       loading={loading}
    //     />
    //   ),
    // },
    {
      label: "Content",
      content: (
        <Content
          selectedTheme={selectedTheme}
          handleImage={handleImage}
          handelThemeData={handelThemeData}
          buttonLoading={buttonLoading}
          loading={loading}
        />
      ),
    },

    // {
    //   label: "Category",
    //   content: (
    //     <CategoryManager
    //       selectedTheme={selectedTheme}
    //       handleImage={handleImage}
    //       handelThemeData={handelThemeData}
    //       loading={loading}
    //       categories={categories}
    //       buttonLoading={buttonLoading}
    //       handleRefresh={getCategories}
    //     />
    //   ),
    // },

    // {
    //   label: "SubCategory",
    //   content: (
    //     <SubCategoryManager
    //       selectedTheme={selectedTheme}
    //       handleImage={handleImage}
    //       handelThemeData={handelThemeData}
    //       loading={loading}
    //       categories={categories}
    //       buttonLoading={buttonLoading}
    //       handleRefresh={getCategories}
    //     />
    //   ),
    // },
    {
      label: "Menu Builder",
      content: (
        <Menu
          selectedTheme={selectedTheme}
          handleImage={handleImage}
          handelThemeData={handelThemeData}
          loading={loading}
          categories={categories}
          buttonLoading={buttonLoading}
          handleRefresh={getCategories}
        />
      ),
    },
  ];

  const getThemes = async (queryTheme) => {
    const { response } = await Service.themes.get({ query: queryTheme });
    if (response) {
      setThemes(response.data);
    } else {
      setThemes([]);
    }
  };

  useEffect(() => {
    getThemes("theme_type=supperadmin");
  }, []);

  const selectTheme = async (theme) => {
    setLoader(true);
    const { response } = await Service.themes.get({
      query: `theme_type=agency&agency_id=${agency?._id}`,
    });
    if (response?.data.length == 0) {
      await Service.themes
        .updateOrCreateByAgencyId({
          payload: {
            agency_id: agency?._id,
            theme_data: theme.theme_data,
            theme_type: "agency",
            theme_id: theme._id,
          },
        })
        .then((response) => {
          setSelectedTheme(response?.response?.data);
          setLoader(false);
        });
    } else {
      setSelectedTheme(response?.data[0]);
      setLoader(false);
    }
  };

  useEffect(() => {
    selectTheme();
  }, []);

  const activeTheme = async () => {
    const payload = {
      _id: agency?._id,
      theme_id: selectedTheme._id,
    };
    const { response } = await Service.agency.update({ payload });
    if (response) {
      const payload = {
        agency_id: agency?._id,
        _id: selectedTheme._id,
        status: "active",
      };

      const { response } = await Service.themes.ActiveOrDeActive({ payload });
      if (response) {
        setOpen(true);
        setSelectedTheme("active");
      }
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleDummyData = async () => {
    const { response } = await Service.webhook.load_dummy_data({
      query: `agency_id=${agency._id}`,
      toaster: false,
    });
    if (response) {
      Update(response.data);
    }
  };
  return (
    <>
      {loader ? (
        <div
          style={{
            height: "100vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(255, 255, 255, 0.7)",
          }}
        >
          <Loader />
        </div>
      ) : (
        <>
          <div>
            <SoftBox p={3} display="flex-col" justifyContent="space-between" alignItems="center">
              <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                {/* <SoftButton
              sx={{ marginBottom: 2 }}
              variant="contained"
              color="black"
              onClick={() => setSelectedTheme([])}
            >
              Back to Themes
            </SoftButton> */}
                {!agency?.load_dummy_data && (
                  <SoftButton
                    onClick={handleDummyData}
                    type="button"
                    variant="contained"
                    color="info"
                  >
                    Load Dummy Data
                  </SoftButton>
                )}
              </SoftBox>

              <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <h1 className="headingpage-branding w-100">
                  Customization for {selectedTheme.name}
                </h1>
                <SoftBox display="flex" justifyContent="end" gap={1} alignItems="center">
                  {console.log(
                    "selectedThemeselectedThemeselectedThemeselectedThemeselectedThemeselectedTheme",
                    selectedTheme
                  )}
                  {selectedTheme?.status === "de_active" ? (
                    <SoftTypography variant="h6" sx={{ fontWeight: 600, color: "green" }}>
                      Applied Theme
                    </SoftTypography>
                  ) : (
                    <SoftButton
                      onClick={activeTheme}
                      type="button"
                      variant="contained"
                      color="black"
                    >
                      Active Theme
                    </SoftButton>
                  )}
                </SoftBox>
              </SoftBox>
              <CustomTabs tabsData={tabsData} />
              {/* <SoftUITabs tabsData={tabsData} selectedTheme={selectedTheme} /> */}
            </SoftBox>
          </div>
        </>
      )}
    </>
  );
}
export default BasicInfo;
